export default "__VITE_ASSET__Dp7Jl1AV__"